import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ParametrizacaoService } from '../parametrizacao.service';
import { ParametroConsultaImpedimento } from '../../../model/parametro-consulta-impedimento.model';
import { BnModalMessageService } from '@bndes/bndes-ux4/bn-modal-message';
import { BnLoadingService } from '@bndes/bndes-ux4/bndes-angular-utils';
import { MensagemService } from '../../mensagem.service';


@Component({
  selector: 'app-parametrizacao-impedimento',
  templateUrl: './parametrizacao-impedimento.component.html',
  styleUrl: './parametrizacao-impedimento.component.scss',
  standalone: false
})
export class ParametrizacaoImpedimentoComponent implements OnInit {

  public formImpedimentoCadin: UntypedFormGroup;
  private parametro?: ParametroConsultaImpedimento;


    constructor(
      private formBuilder: UntypedFormBuilder,
      private parametrizacaoService: ParametrizacaoService,
      private modalService: BnModalMessageService,
      private loadingService: BnLoadingService,
      private mensagemService: MensagemService
    ) {

      this.formImpedimentoCadin = this.formBuilder.group({
        ide: [''],
        quantidadeMaximaDiaria: ['', Validators.required],
        quantidadeMaximaMensal: ['', Validators.required]
      });

    }


    ngOnInit(): void {

      this.buscarParametrizacaoModalidade();
    }


    public async abreModalConfirmacao(mensagem: string): Promise<boolean> {
      const titulo = 'Confirmação';

      try {
        const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
        return resultadoConfimacao.value === 'ok';
      } catch (e) {
        return false;
      }
    }


    private buscarParametrizacaoModalidade() {

      this.parametrizacaoService.buscar().subscribe(resp => {

        this.formImpedimentoCadin.patchValue({
          ide: resp.ide,
          quantidadeMaximaDiaria: resp.quantidadeMaximaDiaria,
          quantidadeMaximaMensal: resp.quantidadeMaximaMensal
        });

      }, error => {
        console.error("Erro ao buscar parametrização: ", error);
      })

    }

    public salvarEditar() {

      this.parametro = this.formImpedimentoCadin.value;

      if (this.parametro?.ide) {

        this.editar(this.parametro);

      } else {

        this.salvar(this.parametro);
      }
    }


    public salvar(parametro: any) {

      this.abreModalConfirmacao('Deseja salvar parametrização impedimento ?').then(resp => {

        if (resp === true && parametro) {

          this.loadingService.bloqueiaTela();

          this.parametrizacaoService.salvar(parametro).subscribe({
            next: (resposta) => {
              this.parametro = resposta;

              this.formImpedimentoCadin.patchValue({
                ide: resposta.ide
              });

              this.mensagemService.adicionarMensagemSucesso('Registro salvo com sucesso.');
              this.loadingService.liberaTela();

            }, error: (error) => {

              this.mensagemService.adicionarMensagemErro("Erro :", " Não foi possível salvar o registro")
              this.loadingService.liberaTela();
            }
          });
        }
      });

    }

    public editar(parametro: ParametroConsultaImpedimento) {

      this.abreModalConfirmacao('Deseja salvar parametrização impedimento?').then(resp => {

        if (resp === true && parametro) {

          this.loadingService.bloqueiaTela();

          this.parametrizacaoService.editar(parametro).subscribe({
            next: (resposta) => {

              this.mensagemService.adicionarMensagemSucesso('Registro salvo com sucesso.');
              this.loadingService.liberaTela();
            }, error: (error) => {
              console.log("Erro")
              this.loadingService.liberaTela();
            }
          });
        }
      });

    }

}